import React from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import SearchInput from "components/SearchInput";
import LinkButton from "ds/components/Button/LinkButton";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import TerraformRegistryViewHeader from "views/Account/TerraformRegistry/ViewHeader";
import { AccountContext } from "views/AccountWrapper";
import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import DesktopView from "components/Mobile/DesktopView";
import PageInfoHeader from "ds/components/PageInfoHeader";
import useCanCreateModule from "shared/Module/access/useCanCreateModule";
import Tooltip from "ds/components/Tooltip";
import { AnalyticsPageModule } from "hooks/useAnalytics/pages/module";
import useTypedFlags from "hooks/useTypedFlags";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import { getDocsUrl } from "utils/getDocsUrl";
import MobileView from "components/Mobile/MobileView";

import { FILTERS_ORDER_SETTINGS_KEY } from "../../constants";

type ModulesPageLayoutProps = {
  children: React.ReactNode;
};

const ModulesPageLayout = ({ children }: ModulesPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const { sharingModulesBetweenSpaces } = useTypedFlags();

  const canCreateModule = useCanCreateModule();

  const showNewNavigation = sharingModulesBetweenSpaces;

  useTitle(`Modules · ${accountName}`);

  return (
    <>
      {!showNewNavigation && <TerraformRegistryViewHeader />}
      {showNewNavigation && (
        <ViewHeader firstLevel>
          <ViewHeaderWrapper>
            <ViewHeaderTitle>Module registry</ViewHeaderTitle>
            <MobileView>
              <Tooltip
                active={!!canCreateModule.message}
                on={(props) => (
                  <LinkButton
                    {...props}
                    to="/new/module"
                    variant="primary"
                    disabled={!canCreateModule.result}
                    analyticsPage={AnalyticsPageModule.ModulesList}
                    analyticsTitle="Create Module"
                  >
                    Create module
                  </LinkButton>
                )}
              >
                {canCreateModule.message}
              </Tooltip>
            </MobileView>
          </ViewHeaderWrapper>
          <ViewHeaderWrapper>
            <SearchInput
              placeholder="Search by name, ID, etc..."
              filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
            />
            <FiltersMobileTriggerButton />
            <DesktopView>
              <DocumentationIconButton
                href={getDocsUrl("/vendors/terraform/module-registry.html")}
                tooltipText="Go to modules documentation"
              />

              <Tooltip
                active={!!canCreateModule.message}
                on={(props) => (
                  <LinkButton
                    {...props}
                    to="/new/module"
                    variant="primary"
                    disabled={!canCreateModule.result}
                    analyticsPage={AnalyticsPageModule.ModulesList}
                    analyticsTitle="Create Module"
                  >
                    Create module
                  </LinkButton>
                )}
              >
                {canCreateModule.message}
              </Tooltip>
            </DesktopView>
          </ViewHeaderWrapper>
        </ViewHeader>
      )}
      {!showNewNavigation && (
        <PageInfoHeader title="Modules">
          <SearchInput
            placeholder="Search by name, ID, etc..."
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />
          <FiltersMobileTriggerButton />

          <DesktopView>
            <Tooltip
              active={!!canCreateModule.message}
              on={(props) => (
                <LinkButton
                  {...props}
                  to="/new/module"
                  variant="primary"
                  disabled={!canCreateModule.result}
                  analyticsPage={AnalyticsPageModule.ModulesList}
                  analyticsTitle="Create Module"
                >
                  Create module
                </LinkButton>
              )}
            >
              {canCreateModule.message}
            </Tooltip>
          </DesktopView>
        </PageInfoHeader>
      )}

      {children}
    </>
  );
};

export default ModulesPageLayout;
